import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLDivElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLDivElement
 */
export default class HTMLDivElement extends HTMLElement {}
